// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__23Etk","log":"ModalInventoryLogs_log__Ddg5D","date":"ModalInventoryLogs_date__3J_c2","userName":"ModalInventoryLogs_userName__3Nlo2"};